import { useState } from 'react';
import { Typography, Box } from '@mui/material';
import PublicLayout from '../components/PublicLayout';
import LoginModal from '../components/LoginModal';
import { useNavigate } from 'react-router-dom';

// Direct navigations to /login (logout redirect, protected-route bounce,
// "session expired") land here: the portal shell with the login modal open.
export default function LoginRoute() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  return (
    <PublicLayout>
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>Welcome back</Typography>
        <Typography color="text.secondary">Sign in to continue to your dashboard.</Typography>
      </Box>
      <LoginModal open={open} onClose={() => { setOpen(false); navigate('/portal'); }} />
    </PublicLayout>
  );
}